<template>
  <div>
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="100"
    >
    <FormItem label="所属分类"  prop="classify_id" v-if="classifyIds.length > 1">
        <Select v-model="formValidate.classify_id">
          <Option
            v-for="item in classifyIds"
            :value="item.id"
            :key="item.id"
            >{{ item.name}}</Option
          >
        </Select>
      </FormItem>

      <FormItem label="平台"  prop="live_id">
        <Select v-model="formValidate.live_id">
          <Option
            v-for="item in liveTypes"
            :value="item.id"
            :key="item.id"
            >{{ item.name}}</Option
          >
        </Select>
      </FormItem>

      <FormItem label="gpt模型"  prop="gpt_model_id">
        <Select v-model="formValidate.gpt_model_id">
          <Option
            v-for="item in gptModelIds"
            :value="item.id"
            :key="item.id"
            >{{ item.name}}</Option
          >
        </Select>
      </FormItem>


      <FormItem label="画像标准话术" prop="stand_text">
        <Input v-model="formValidate.stand_text" type="textarea" placeholder="请输入画像标准话术"></Input>
      </FormItem>

      <FormItem style="text-align: right">
        <Button @click="handleReset('formValidate')">重置</Button>
        <Button
          type="primary"
          @click="handleSubmit('formValidate')"
          style="margin-left: 8px"
          >提交</Button
        >
      </FormItem>
    </Form>
  </div>
</template>

<script>
import params from '../argu-page/params.vue'
export default {
  components: { params },
  props: {
    resetFlag: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: () => {}
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      liveTypes: [],
      taskTypes:[],
      comments:[],
      userIds:[],
      classifyIds:[],
      gptModelIds:[],
      formValidate: {
        id: '',
        stand_text:'',
        live_id:'',
        gpt_model_id:'',
        classify_id:0
      },
      ruleValidate: {
        classify_id: [
          {
            required: true,
            message: '选择任务类型',
            trigger: 'change'
          }
        ],
        stand_text: [
          {
            required: true,
            message: '画像标准话术',
            trigger: 'blur'
          }
        ],
        live_id: [
          {
            required: true,
            message: '选择平台',
            trigger: 'change'
          }
        ]
        
      }
    }
  },
  watch: {
    resetFlag (resetFlag) {
      this.handleReset('formValidate')
    }
  },
  methods: {
    setGptModel (gptModels) {
      var data = new Array()
      for (var i = 0; i < gptModels.length; i++) {
        data[i] = { id: gptModels[i].id.toString(), name: gptModels[i].gpt_model}
      }
      this.gptModelIds = data
    },
    setClassify (classify_list) {
      var data = new Array()
      for (var i = 0; i < classify_list.length; i++) {
        data[i] = { id: classify_list[i].id.toString(), name: classify_list[i].name }
      }
      this.classifyIds = data
    },
    setLiveType (classify_list) {
      var data = new Array()
      for (var i = 0; i < classify_list.length; i++) {
        data[i] = { id: classify_list[i].id.toString(), name: classify_list[i].name }
      }
      this.liveTypes = data

    },filterMethod (data, query) {
      return data.label.indexOf(query) > -1
    },
    handleChange (newTargetKeys) {
      this.formValidate.users = newTargetKeys
    },
    setEditData (data) {
      this.formValidate.id = data.id
      this.formValidate.classify_id = data.classify_id.toString()
      this.formValidate.live_id = data.live_id.toString()
      this.formValidate.gpt_model_id = data.model_id.toString()
      this.formValidate.stand_text = data.stand_text
    },
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$emit('on-ok', this.formValidate)
        } else {
          this.$Message.error('失败!')
        }
      })
    },
    handleReset (name) {
      this.$refs[name].resetFields()
    }
  }
}
</script>
